import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'
import type { CompanyHouseCheck, CompanyType, OrganisationStatus } from '@/types/Activity'

const verifyOrganisationMutation = gql`
  mutation (
    $customerId: String!
    $subjectId: String!
    $request: VerifyOrganisationInput!
    $userId: String!
  ) {
    verifyOrganisation(
      customerId: $customerId
      subjectId: $subjectId
      request: $request
      userId: $userId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  request: VerifyOrganisationRequest
}

export interface VerifyOrganisationRequest {
  companyHouseCheck: CompanyHouseCheck
  companyType: CompanyType
  organisationStatus: OrganisationStatus
  incorporationDate: string
  filedAccount: string | null
  companyNumber: string
}

export type VerifyOrganisationData = {
  verifyOrganisationData: string | unknown
}

export const useVerifyOrganisationMutation: WrappedMutation<
  VerifyOrganisationData,
  MutationVars
> = () =>
  useMutation<VerifyOrganisationData, MutationVars>(verifyOrganisationMutation, {
    client: agentClient,
  })
